﻿<script setup lang="ts">
    import { ref, onMounted, watch, inject, reactive, provide } from 'vue';
    import { RouterView, useRoute } from 'vue-router';
    import { FeatureService } from '@shared/directives/Feature.service';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import TextMessagesTopNav from './TextMessages/TextMessagesTopNav.vue';
    import EventNavbarTopNav from './Event/EventNavbarTopNav.vue';

    export type displayMode = 'default' | 'editor';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const featureAccess: FeatureService = injectorAccess.injector.get(FeatureService);

    const isLoading = ref<boolean>(true);
    const currentRouteName = ref<null | string>(null);
    const route = useRoute();

    const state = reactive<{
        mode: displayMode;
    }>({
        mode: 'default',
    });

    provide('mode', state.mode);

    onMounted(async () => {
        isLoading.value = false;
        currentRouteName.value = route.name as string;

        watch(
            () => route?.name,
            async (newName) => {
                currentRouteName.value = newName as string;
            }
        );
    });
</script>

<template>
    <TextMessagesTopNav v-if="route.path.startsWith('/TextMessages')" :currentRouteName="currentRouteName" />
    <EventNavbarTopNav :currentRouteName="currentRouteName" />

    <div class="return" v-if="route.name === 'FormsEditor' || route.name === 'FormsNew'">
        <span class="glyphicon glyphicon-chevron-left m-xxs-r"></span>
        <router-link :to="{ name: 'Forms' }">{{ $Resources.FormsBackBtn }}</router-link>
    </div>

    <Suspense v-if="!isLoading">
        <router-view v-slot="{ Component }">
            <keep-alive>
                <component :is="Component" />
            </keep-alive>
        </router-view>
    </Suspense>
</template>

<style scoped></style>

<style>
    .return {
        position: absolute;
        z-index: 1;
        padding: 15px;
        font-weight: 700;
        top: 25px;
    }
</style>
